// Telefones brasileiros no chat: normalização para envio/busca e detecção de número
// solto no texto (o atendente manda "11 98765-4321" pelo celular da loja em vez de um
// cartão, e o número tem de virar ação do mesmo jeito que o cartão).

/** Só os dígitos, sem o 55 do país. */
export function nationalDigits(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  if ((digits.length === 12 || digits.length === 13) && digits.startsWith('55')) {
    return digits.slice(2);
  }
  return digits;
}

/** DDD válido (11..99) seguido de 8 dígitos (fixo ou WhatsApp sem o 9) ou 9 com o 9. */
function isValidNational(n: string): boolean {
  if (!/^[1-9][1-9]/.test(n)) return false;
  if (n.length === 11) return n[2] === '9';
  if (n.length === 10) return /[2-9]/.test(n[2]!);
  return false;
}

/** Número com país (55 + DDD + número), só dígitos, ou null se não parece telefone BR. */
export function toE164Digits(phone: string): string | null {
  const n = nationalDigits(phone);
  return isValidNational(n) ? `55${n}` : null;
}

export interface PhoneMatch {
  start: number;
  end: number;
  /** Como está escrito no texto. */
  raw: string;
  /** 55 + DDD + número. */
  digits: string;
}

// Candidato: +55 opcional, DDD com ou sem parênteses, 4 ou 5 dígitos, separador opcional,
// 4 dígitos. Os limites (?<!\d)/(?!\d) evitam pegar pedaço de um número maior.
const CANDIDATE_RE =
  /(?<![\d+])(?:\+?55[\s.-]?)?(?:\(\s*[1-9]{2}\s*\)|[1-9]{2})[\s.-]?9?\s?\d{4}[\s.-]?\d{4}(?!\d)/g;

/** Telefones BR no texto, na ordem em que aparecem. */
export function findPhones(text: string): PhoneMatch[] {
  const out: PhoneMatch[] = [];
  for (const m of text.matchAll(CANDIDATE_RE)) {
    const digits = toE164Digits(m[0]);
    if (!digits) continue;
    const start = m.index ?? 0;
    out.push({ start, end: start + m[0].length, raw: m[0], digits });
  }
  return out;
}
